"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromTokenFile = void 0;
const credential_provider_web_identity_1 = require("@aws-sdk/credential-provider-web-identity");
const fromTokenFile = (init = {}) => (0, credential_provider_web_identity_1.fromTokenFile)({
    ...init,
});
exports.fromTokenFile = fromTokenFile;
